import { ReactComponent as BackButtonIcon } from "@icons/back.svg";
import { PropsWithChildren } from "react";
import { ResponsiveBreakpoints } from "shared/UI/ResponsiveBreakpoints";
import { useMatchMedia } from "shared/UI/Hooks/useMatchMedia";
import { useTranslation } from "react-i18next";
import { Modal } from "shared/UI/Modal/Modal";

export type FullScreenModalProps = {
  title: string;
  onClose: VoidFunction;
} & PropsWithChildren;

export const FullScreenModal = ({ title, children, onClose }: FullScreenModalProps) => {
  const { t } = useTranslation();
  const largerDisplay = useMatchMedia(ResponsiveBreakpoints.Tablet);
  return (
    <>
      {!largerDisplay && (
        <div data-testid="fullScreenModal" className="fixed top-0 left-0 w-full h-screen z-MODAL bg-white">
          <div className="relative h-full p-10 text-white">
            <button className="pr-2" aria-label={t("navigation.backButton")} onClick={onClose}>
              <BackButtonIcon className="text-brand-purple" width="30" title={t("navigation.backButton")} />
            </button>
            {children}
          </div>
        </div>
      )}

      {largerDisplay && (
        <Modal close={onClose} title={title}>
          {children}
        </Modal>
      )}
    </>
  );
};